/** File with TPA assignment and upload status tracking */

import { CommonStatus } from "./common";

/** Upload status states for file assignments */
export enum FileUploadStatus {
  PENDING = CommonStatus.PENDING,
  ASSIGNED = "assigned",
  UPLOADING = "uploading",
  COMPLETED = CommonStatus.COMPLETED,
  ERROR = CommonStatus.ERROR,
}

/** Internal upload result status */
export enum UploadResultStatus {
  SUCCESS = CommonStatus.SUCCESS,
  ERROR = CommonStatus.ERROR,
}

/** File with TPA assignment and upload status tracking */
export interface FileAssignment {
  id: string;
  file: File;
  filename: string;
  size: number;
  type: string;
  carrierId?: string;
  carrierName?: string;
  status: FileUploadStatus;
  error?: string;
  /**
   * Workbook sheet names discovered client-side at file-drop time
   * (xlsx/xls). undefined for non-spreadsheet files. Single-sheet
   * workbooks produce a one-element array. ADO #4267 (MSW-3).
   */
  sheetNames?: string[];
  /**
   * Sheet names the user selected from the multi-sheet picker
   * (VendorAssignmentDialog, MSW-4). Empty/undefined means no
   * picker rendered or no selection made yet. MSW-5 dispatches
   * one upload per entry, each carrying X-Sheet-Name.
   */
  selectedSheets?: string[];
  /**
   * Reviewer flag (reimbursement uploads only): this file is a multi-client
   * ("book of business") carrier register — uploaded with no single client; rows
   * resolve a client/policy each (#5309 / ADR-057). Drives the X-Multi-Client
   * upload header. Set in the Prepare-upload (VendorAssignment) dialog.
   */
  is_multi_client?: boolean;
}

/** Result of an individual file upload attempt */
export interface UploadResult {
  id: string;
  status: UploadResultStatus;
  error?: string;
}

export enum DropzoneDocumentType {
  CLAIMS = "CLAIMS",
  POLICIES = "POLICIES",
  REIMBURSEMENTS = "REIMBURSEMENTS",
  ATTACHMENTS = "ATTACHMENTS",
}
